export class Gauge {
    constructor(selectorOrElement) {
        this.el = selectorOrElement instanceof Element
        ? selectorOrElement
        : document.querySelector(selectorOrElement);

        if (!this.el) {
            console.warn(`Gauge: No element found for "${selectorOrElement}"`);
            return;
        }

        this.START_ANGLE = 250;
        this.TOTAL_ANGLE = 220;

        this.svgEl = this.el.querySelector('svg');
        this.perc  = this.el.querySelector('text.percentage');
        this.arc   = null;

        this._drawTrack();
        this.init();
    }

    polarToCartesian(cx, cy, radius, angle) {
        const radians = (angle - 90) * Math.PI / 180.0;
        return [
            Math.round((cx + radius * Math.cos(radians)) * 100) / 100,
            Math.round((cy + radius * Math.sin(radians)) * 100) / 100
        ];
    }

    svgCircleArcPath(x, y, radius, startAngle, endAngle) {
        const startXY      = this.polarToCartesian(x, y, radius, startAngle);
        const endXY        = this.polarToCartesian(x, y, radius, endAngle);
        const largeArcFlag = (endAngle - startAngle) > 180 ? 1 : 0;
        return `M ${startXY[0]} ${startXY[1]} A ${radius} ${radius} 0 ${largeArcFlag} 1 ${endXY[0]} ${endXY[1]}`;
    }

    _drawTrack() {
        const track = this.svgEl.querySelector('.track-arc');
        if (!track) return;
        const path = this.svgCircleArcPath(
            500, 500, 450,
            this.START_ANGLE,
            this.START_ANGLE + this.TOTAL_ANGLE
        );
        track.setAttribute('d', path);
    }

    // Gibt die interpolierte Farbe für einen gegebenen Prozentwert zurück
    _colorForValue(pct) {
          if (pct >= 90) return '#EF4444';
          if (pct >= 70) return '#eab308';
          return '#2563EB';
    }

    animateArc(ratio) {
        if (this.arc) this.arc.remove();
        this.arc = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        this.arc.classList.add('data-arc');
        this.svgEl.insertBefore(this.arc, this.perc);

        const duration  = Math.round(1500 * ratio);
        const startTime = performance.now();

        const tick = (now) => {
            const elapsed = Math.min(now - startTime, duration);
            const t       = duration > 0 ? elapsed / duration : 1;
            const ease    = t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
            const val     = ease * ratio;
            const pct     = val * 100;

            const endAngle = this.START_ANGLE + val * this.TOTAL_ANGLE;
            this.arc.setAttribute('d',
                this.svgCircleArcPath(500, 500, 450, this.START_ANGLE, endAngle)
            );
            const color = this._colorForValue(pct);
            this.arc.style.stroke  = color;
            this.perc.style.fill   = color;
            this.perc.textContent  = `${Math.round(pct)}%`;

            if (elapsed < duration) requestAnimationFrame(tick);
        };

        requestAnimationFrame(tick);
    }

    init() {
        const ratio = parseFloat(this.el.dataset.ratio);
        this.animateArc(ratio);
    }
}